import { render } from "./UpdateServiceModal.vue?vue&type=template&id=d6ea9c6c"
import script from "./UpdateServiceModal.vue?vue&type=script&lang=js"
export * from "./UpdateServiceModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Intermark\\Intermark(mobile)\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__